import { Component, OnInit, Optional, Inject, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
} from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { TransactionsService } from '../../../core/functions/transactions.service';

const ONE_DAY = 86400000;
const ONE_MONTH = 2592000000;
@Component({
  selector: 'makaw-set-target-modal',
  templateUrl: './set-target-modal.component.html',
  styleUrls: ['./set-target-modal.component.scss'],
})
export class SetTargetModalComponent implements OnInit, OnDestroy {
  public setTargetForm: FormGroup;
  public cancel = false;
  public action: string;
  public headerMessage: string;
  public today = new Date();
  public dayAfterTomorrow = new Date(this.today.getTime() + ONE_DAY * 2);
  public dataSet;
  public maximumSavings;
  public savings = 0;
  public expenseNet;
  public rate;
  public monthly;
  public daily;
  private destroyed$ = new Subject();

  constructor(
    public dialogRef: MatDialogRef<SetTargetModalComponent>,
    // @Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    private readonly transactionCalculationLibrary: TransactionsService
  ) {
    this.dataSet = this.data.dataSet;
    this.headerMessage = this.data.msg;
    this.action = data.action;
    this._buildSavingsGoalForm();
  }

  public ngOnInit() {
    this.setTargetForm
      .get('date')
      .valueChanges.pipe(takeUntil(this.destroyed$))
      .subscribe((value) => this._calculateMaximumSaving());

    this.setTargetForm
      .get('savings')
      .valueChanges.pipe(takeUntil(this.destroyed$))
      .subscribe((value) => this._calculateSaving());
  }

  private _buildSavingsGoalForm() {
    this.setTargetForm = this.formBuilder.group({
      date: new FormControl(
        '',
        Validators.compose([Validators.required, Validators.maxLength(32)])
      ),
      savings: new FormControl(
        '',
        Validators.compose([Validators.required, Validators.maxLength(32)])
      ),
    });
  }

  private _calculateMaximumSaving() {
    const c = this.setTargetForm;
    const targetDate = c.get('date').value
      ? new Date(c.get('date').value)
      : this.dayAfterTomorrow;
    const sortedDataSet = this.dataSet.reverse();
    this.maximumSavings = this.transactionCalculationLibrary.getBalanceSpecificDay(
      sortedDataSet,
      targetDate
    );
  }

  private _calculateSaving() {
    const saving = this.setTargetForm.get('savings').value;
    this.rate = saving / this.maximumSavings;
    const oneDay = 86400000;
    const oneMonth = 2592000000;

    const today = new Date(this.today).getTime();
    const targetDate = new Date(this.setTargetForm.get('date').value).getTime();

    const difference = targetDate - today;
    const daysApart = difference / oneDay;
    const monthsApart = difference / oneMonth;

    this.expenseNet = this.maximumSavings - saving;
    this.daily = daysApart < 1 ? 0 : this.expenseNet / daysApart;
    this.monthly = monthsApart < 1 ? 0 : this.expenseNet / monthsApart;
  }

  public closeDialog() {
    this.cancel = true;
    this.dialogRef.close({ event: 'Cancel' });
  }

  public onSubmit() {
    // if (!this.cancel) this.doAction();
  }

  public ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
